export default "__VITE_ASSET__26c27187__"